export type NativeMessageHandler = {
    postMessage: (payload: unknown) => void
}

type WebkitBridge = {
    messageHandlers?: Record<string, NativeMessageHandler | undefined>
}

declare global {
    interface Window {
        webkit?: WebkitBridge
    }
}

export function getNativeMessageHandler(name: string): NativeMessageHandler | null {
    if (typeof window === 'undefined') {
        return null
    }

    return window.webkit?.messageHandlers?.[name] ?? null
}

export function hasNativeMessageHandler(name: string): boolean {
    return Boolean(getNativeMessageHandler(name))
}
